module.exports = __webpack_public_path__ + "static/media/1POLICY6.2a162276.jpg";